<template>
  <protected-pages-layout>
    <div
      v-if="!loading"
      class="d-flex justify-content-center align-items-center m-5"
    >
      <div
        class="spinner-border text-dark"
        style="width: 7.5rem; height: 7.5rem"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="wrapper" v-else>
      <div class="row d-flex scroll-container">
        <div
          class="col-md-4"
          v-for="(v, index) in teams"
          :key="index"
          style="margin-top: 30px"
        >
          <div class="card border-0 shadow">
            <router-link
              class="team_name_card"
              tag="div"
              :to="'/teams/' + v.Team.ID"
            >
              <h4 style="margin-top: 20px">
                <span class="team_name">{{ v.Team.Name }}</span>
              </h4>
            </router-link>
            <ul class="list-group list-group-flush" style="margin-top: 10px">
              <li
                class="list-group-item"
                :key="memberIndex"
                v-for="(member, memberIndex) in v.Members"
              >
                {{ member.Name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </protected-pages-layout>
</template>

<script setup>
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useTeamStore } from "../stores/team.js";

const teamStore = useTeamStore();

const {
  getTeams: teams,
  getTeamMembers: teamMembers,
  getLoading: loading,
} = storeToRefs(teamStore);

console.log(teams);

const { fetchTeams } = teamStore;

onMounted(async () => {
  await fetchTeams();
});
</script>

<script>
import Navbar from "../components/Navbar.vue";
export default {
  components: {
    Navbar,
  },
};
</script>

<style scoped>
span {
  border-bottom: solid 3px transparent;
  border-color: transparent;
}

span:hover {
  border-bottom: solid 3px #fe938c;
  transition: border-color 0.3s ease;
  cursor: pointer;
}
.scroll-container {
  overflow-y: auto;
  max-height: 100vh;
  padding-bottom: 100px;
}
</style>
